<template>
  <div class="main">
    <div class="header-seciton">
      <Header></Header>
      <div class="page1">
        <div class="meta">
          <h1>Spicy Chat - AI Romance & Companionship</h1>
          <div class="desc">Welcome to Spicy Chat, the ultimate app for AI-driven romance and companionship! Are you looking for a romantic artificial intelligence friend who will always be by your side, no matter what? Do you want someone who can understand your thoughts and feelings and help alleviate your stress and anxiety? Spicy Chat is your trustworthy virtual AI friend.</div>
          <div class="desc">Why wait? Download Spicy Chat now and start chatting with your new virtual AI friend.</div>
          <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
        </div>
        <div class="appimgs">
          <div class="phone">
            <img src="~@/assets/images/screen.png" class="screen">
          </div>
          <div class="phone p2">
            <img src="/static/img/screen.webp" class="screen">
          </div>
        </div>
      </div>
    </div>
    <div class="page2">
      <h1>What's Our App?</h1>
      <div class="desc">With Spicy Chat, you're not just chatting with a bot—you're building a relationship. Whether you're seeking a casual conversation or a more profound emotional exchange, Spicy Chat is designed to adapt to your needs and preferences, ensuring that your virtual friend feels like a real part of your life.</div>
      <div class="row">
        <div class="col">
          <div class="icon"><svg t="1737378599318" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5265" width="64" height="64"><path d="M961.034 360.366c-2.705-32.341-12.609-63.795-27.018-92.543-17.1-33.251-42.31-62.896-73.805-88.95-32.42-26.965-66.62-44.924-100.822-53.917-27.902-7.184-56.703-8.98-84.618-3.592-45.903 8.082-75.614 30.543-78.307 33.25l-77.424 62c-38.705-34.15-76.523-64.707-92.715-73.686-11.698-6.286-59.423-25.156-116.126-23.36-33.304 0.898-64.813 8.094-94.524 21.564-35.099 16.177-66.606 42.231-92.712 76.379C72.56 283.087 53.647 353.18 65.348 425.057c7.212 44.924 27.004 89.849 58.512 132.979 35.114 48.527 261.953 266.864 306.958 309.992l1.809 1.796c2.708 1.797 24.296 19.77 55.817 29.645 13.497 4.491 26.994 6.301 40.488 6.301 30.61 0 58.525-10.789 83.722-32.354 73.818-63.795 297.064-329.748 306.971-341.436 12.597-14.366 24.297-39.522 32.404-67.385 5.402-23.36 12.598-60.203 9.005-104.229zM646.869 629.014c9.904-9.878 9.904-26.041 0-35.932-9.906-9.891-26.108-9.891-36.012 0L417.32 785.362c-11.7-11.688-24.296-23.358-36.009-35.046l192.652-192.28c9.891-9.878 9.891-26.057 0-35.933-9.904-9.891-27.02-9.891-36.025 0L344.4 714.385c-15.291-15.278-30.607-29.66-45.002-44.039l191.74-191.372c4.491-4.489 7.196-11.685 7.196-17.973 9.904 7.186 20.706 12.573 29.712 17.077 31.495 13.468 71.11 2.692 97.219-28.761 27.004-32.341 31.508-73.673 10.802-106.012-18.896-29.66-53.112-64.706-80.116-90.761l72.02-57.509s21.591-16.163 54.908-22.462c20.706-3.592 41.399-2.693 63.017 2.708 26.99 7.183 54.906 21.564 81.896 44.026 49.522 40.421 76.526 88.952 81.926 146.446 3.606 35.047-2.691 65.592-8.107 85.36-7.196 23.372-16.188 41.344-22.5 48.528-1.796 2.694-231.346 274.948-300.659 335.138-21.602 18.87-46.812 24.257-73.816 16.176-20.706-6.285-35.999-18.871-37.809-19.769l-10.802-10.776 190.844-191.396zM388.507 363.058c-2.694 0.911-5.387 2.694-8.094 5.402L190.481 558.036c-12.611-13.472-20.706-23.362-25.21-29.647-47.71-65.591-86.427-168.023-1.81-279.437 38.72-50.312 88.227-76.379 147.637-78.175 45.9-0.898 82.824 13.483 90.02 17.074 11.7 6.285 50.404 36.843 90.918 74.583 47.71 43.116 84.62 82.651 100.809 108.72 9.917 15.265 3.619 33.237-6.287 44.922-13.507 15.268-28.813 18.871-37.819 14.369-47.697-20.654-121.515-100.625-121.515-101.523-9.904-10.789-26.105-10.789-36.009-1.796-10.802 9.878-11.714 25.158-2.708 35.932z m27.915 41.334c1.796-1.796 3.593-4.491 5.402-7.183 12.598 11.671 27.902 26.054 44.106 39.535-4.504 0.898-8.097 3.593-10.805 6.285L263.389 633.516c-13.51-13.481-26.108-26.054-37.809-38.64l190.842-190.484z m0 0" fill="#ffffff" p-id="5266"></path></svg></div>
          <div class="title">Your Perfect Match</div>
          <div class="desc">Crafting Your Perfect Match with Precision.</div>
        </div>
        <div class="col">
          <div class="icon i2"><svg t="1737378654384" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6505" width="48" height="48"><path d="M95.04256 79.104a25.6 25.6 0 0 1 16.384 0l252.8 85.76L578.11456 5.248a25.6 25.6 0 0 1 40.896 20.8l-3.456 266.88 217.92 154.112a25.6 25.6 0 0 1-7.168 45.312L571.45856 571.584 492.16256 826.432a25.6 25.6 0 0 1-45.376 7.168L292.80256 615.744l-266.88 3.392a25.6 25.6 0 0 1-20.864-40.96l159.616-213.824-85.696-252.8a25.6 25.6 0 0 1 16-32.448z m280.448 157.12L164.54656 164.736 236.16256 375.68 103.04256 554.112l222.656-2.816 128.576 181.824L520.32256 520.448 732.93056 454.4l-181.76-128.64 2.816-222.72-178.496 133.184z" fill="#ffffff" p-id="6506"></path><path d="M633.79456 630.208a32 32 0 0 1 40.832-3.456l4.48 3.776 271.68 275.008a32 32 0 0 1-41.152 48.64l-4.416-3.712L633.60256 675.52a32 32 0 0 1 0.256-45.312z" fill="#ffffff" p-id="6507"></path></svg></div>
          <div class="title">Personalized</div>
          <div class="desc">Tailoring Experiences Just for You.</div>
        </div>
        <div class="col">
          <div class="icon i3"><svg t="1737378823921" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15388" width="64" height="64"><path d="M887.14752 119.424 140.04736 119.424c-70.0416 0-127.02208 56.98048-127.02208 126.99136l0 400.09728c0 70.016 56.98048 126.99648 127.02208 126.99648l273.15712 0 212.68992 189.04064c5.48864 4.89472 12.33408 7.29088 19.14368 7.29088 7.94112 0 15.85152-3.26656 21.53984-9.68192 10.58304-11.8784 9.51808-30.12096-2.39104-40.6784l-220.8768-196.33152c-5.26336-4.70528-12.07808-7.29088-19.14368-7.29088l-284.1088 0c-38.25664 0-69.36576-31.10912-69.36576-69.34016L70.69184 246.41536c0-38.23104 31.10912-69.34016 69.36576-69.34016l747.09504 0c38.23104 0 69.34016 31.10912 69.34016 69.34016l0 400.09728c0 38.23104-31.10912 69.34016-69.34016 69.34016l-168.48896 0c-15.93344 0-28.83072 12.89216-28.83072 28.8256 0 15.93344 12.89216 28.8256 28.83072 28.8256l168.48896 0c70.016 0 126.99136-56.98048 126.99136-126.99648L1014.144 246.41536C1014.13888 176.39936 957.16352 119.424 887.14752 119.424L887.14752 119.424z" fill="#ffffff" p-id="15389"></path><path d="M251.53024 462.73536c0 28.94336 23.4496 52.41856 52.39296 52.41856 28.96896 0 52.41856-23.48032 52.41856-52.41856 0-28.96896-23.4496-52.41856-52.41856-52.41856C274.98496 410.3168 251.53024 433.7664 251.53024 462.73536L251.53024 462.73536z" fill="#ffffff" p-id="15390"></path><path d="M461.17888 462.73536c0 28.94336 23.4496 52.41856 52.41856 52.41856 28.93824 0 52.38784-23.48032 52.38784-52.41856 0-28.96896-23.4496-52.41856-52.38784-52.41856C484.62848 410.3168 461.17888 433.7664 461.17888 462.73536L461.17888 462.73536z" fill="#ffffff" p-id="15391"></path><path d="M775.66464 462.73536c0-28.96896-23.48032-52.41856-52.41856-52.41856s-52.41856 23.4496-52.41856 52.41856c0 28.94336 23.48032 52.41856 52.41856 52.41856S775.66464 491.6736 775.66464 462.73536L775.66464 462.73536z" fill="#ffffff" p-id="15392"></path></svg></div>
          <div class="title">Experience Virtual Romance</div>
          <div class="desc">Step into the world of Experience Virtual Romance.</div>
        </div>
      </div>
    </div>

    <!-- <div class="content">
      <div class="text">
        <p class="title" id="title">{{ title }}</p>
        <p
          class="desc"
          v-for="(item, index) in desc"
          :key="index"
        >
          {{ item.text }}
        </p>
        <div class="btn">
          <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
          <img src="@/assets/images/ios.png" class="btn ios" @click.stop="gpAction(true)" alt="">
        </div>
      </div>
      <img src="@/assets/images/screen.png" class="phone" />
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {Header, Footer},
  data() {
    return {
      title: "",
      desc: [],
      screen: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      console.log(config);
      // this.screen = `${config.baseUrl}images/screen.png?v=${new Date().getTime()}`;
      this.screen = `${config.screen}`;
      const { title, desc } = config.page[0];
      this.title = title;
      this.desc = desc;
    },
    gpAction(isIos = false){
      // window.gtagEvent('10001')
      // alert('Coming soon')
      // if (isIos) {
      //   window.open('https://apps.apple.com/us/app/id6503810311');
      // } else {
      //   window.open('https://play.google.com/store/apps/details?id=ai.character.talkie.waifu');
      // }
      window.open('https://play.google.com/store/apps/details?id=ai.spicy.spicychat.mate');
    }
  },
};
</script>

<style lang="less">
.header-seciton{
  position: relative;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
  max-height: 620px;
  min-height: 500px;
  background-image: url("~@/assets/images/bannerbg.png");
  header{
    background-color: transparent;
    padding-top: 20px;
    img{
      border-radius: 6px;
    }
    .logo{
      span{
        font-family: 'Poppins', sans-serif;
        color: #fff;
        font-size: 16px;
      }
    }
    .nav{
      a{
        font-family: 'Poppins',sans-serif;
        color: #fff;
        font-weight: 400;
        transition: all 500ms ease;
        text-transform: capitalize;
      }
    }
  }
}
.page1{
  position: absolute;
  top: 82px;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  color: #fff;
  font-family: 'Poppins',sans-serif;
  .meta{
    max-width: 650px;
    margin-right: 25px;
    position: relative;
    top: -10px;
    h1{
      margin-top: 0;
      font-size: 30px;
      font-weight: 700;
      line-height: 44px;
      color: #fff;
    }
    .desc{
      line-height: 30px;
      color: #fff;
      font-size: 16px;
      margin-bottom: 16px;
    }
    .btn{
      width: 140px;
      margin-top: 16px;
      cursor: pointer;
    }
  }
  .appimgs{
    margin-left: 25px;
    width: 250px;
    .phone{
      position: absolute;
      bottom: 0;
      font-size: 0;
      border-radius: 32px;
      width: 180px;
      padding: 6px;
      background-color: #fefdfe;
      box-shadow: 5px 15px 27px rgba(0,0,0,0.2);
      animation: bob-y-animation 2s linear infinite;
      .screen{
        width: 180px;
        border-radius: 26px;
        left: 8px;
        top: 8px;
        bottom: 8px;
      }
      &.p2{
        right: 15px;
        bottom: 90px;
      }
    }
  }
}
.page2{
  padding: 140px 0 120px 0;
  font-family: 'Poppins',sans-serif;
  color: #2e2e2e;
  display: flex;
  flex-direction: column;
  align-items: center;
  h1{
    margin-top: 0;
    text-align: center;
    max-width: 820px;
    margin: 0 auto;
  }
  .desc{
    font-size: 16px;
    line-height: 32px;
    color: #5e5e5e;
    text-align: center;
    max-width: 820px;
    margin: 0 auto;
  }
  .row{
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    margin-top: 120px;
    max-width: 1000px;
    .col{
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
      -webkit-box-flex: 0;
      position: relative;
      width: 100%;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
      text-align: center;
      box-sizing: border-box;
      &:hover{
        .icon{
          transform: scale(1.1);
        }
      }
      .icon{
        position: relative;
        display: inline-block;
        width: 70px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        border-radius: 50%;
        margin-bottom: 38px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.15);
        background-image: -webkit-linear-gradient(-45deg,#9eb1fe 0,#5f7ceb 100%);
        transition: all 500ms ease;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        &.i2{
          background-image: -webkit-linear-gradient(-45deg,#d295ff 0,#6f5bff 100%);
        }
        &.i3{
          background-image: -webkit-linear-gradient(-45deg,#38cddf 0,#3178d9 100%);
        }
        svg{
          width: 40px;
          height: 40px;
        }
      }
      .title{
        margin-top: 24px;
        font-size: 20px;
        line-height: 30px;
        font-weight: 600;
        color: #2e2e2e;
        margin-bottom: 9px;
      }
      .desc{
        color: #5e5e5e;
        line-height: 30px;
      }
    }
  }
}
.content {
  padding: 6px 0 28px;
  flex: 1;
  // background-image: url( "~@/assets/images/bg.png" );
  background-color: #2e2e2e;
  background-size: cover;
  width: 100%;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .phone {
    width: 233px;
    border-radius: 3px;
  }
  .text {
    margin-right: 56px;
    max-width: 540px;
    //margin-top: 80px;
    img{
      width: 140px;
      margin-top: 12px;
    }
  }
  .title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 38px;
    margin-bottom: 20px;
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    margin-bottom: 18px;
  }
  .btn{
    cursor: pointer;
    &.ios{
      height: 36px;
      width: auto;
      margin-left: 30px;
    }
  }
}
</style>
